import { styled, Box, Card, Stack } from "@mui/material";
import Typography from "@mui/material/node/Typography";
import {
  HAPCardCustomIcon,
  ClipboardCustomIcon,
  StyledLink,
} from "react-common-ui-library";

export const StyledHAPIcon = styled(HAPCardCustomIcon)(() => ({
  height: "108px",
  width: "160px",
}));

export const StyledClipboardIcon = styled(ClipboardCustomIcon)(() => ({
  height: "160px",
  width: "102px",
}));

export const StyledAccountTypeTypography = styled(Typography)(() => ({
  display: "inline-block",
}));

export const StyledAccountTypeLink = styled(StyledLink)(() => ({
  display: "inline-block",
}));

export const StyledChooseAccountTypeCard = styled(Card)(({ theme }) => ({
  boxShadow: theme.shadows[25],
  padding: theme.spacing(4),
  [theme.breakpoints.down("sm")]: {
    padding: `${theme.spacing(4)} ${theme.spacing(2)}`,
  },
}));
export const StyledTypographyStack = styled(Stack)(({ theme }) => ({
  height: "97px",
  [theme.breakpoints.down("sm")]: {
    height: "auto",
  },
}));

export const StyledAccountTypeIconBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "160px",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));
